import styled, { css } from "styled-components";
import { breakpoints } from "./size";

const visibleScrollbar = css`
  scrollbar-width: auto;
  scrollbar-color: ${(props) => props.theme.green} ${(props) => props.theme.cardBg};

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.cardBg};
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.green};
    border-radius: 999px;
    border: 3px solid ${(props) => props.theme.cardBg};
  }
`;

export const IntroTopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    width: 100%;
  }
`;

export const IntroTopSearch = styled.div`
  display: flex;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;

export const SearchWrap = styled.div`
  position: relative;
  border-radius: 7px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  margin-right: 10px;
  padding-left: 10px;

  input {
    background: transparent;
    border: none;
    height: 30px;
    outline: none;
    width: 221px;
    color: ${(props) => props.theme.textSecondary};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;

    &::placeholder {
      color: ${(props) => props.theme.textPlaceholder};
    }
  }
`;

export const CompanreButton = styled.button`
  border-radius: 7px;
  background-color: ${(props) => props.theme.green};
  border: none;
  padding: 13px 10px;
  color: ${(props) => props.theme.textOnAccent};
  font-family: "SpaceGrotesk";
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  text-transform: uppercase;
  cursor: pointer;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const TopTableNames = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  position: relative;
  width: 100%;

  button {
    position: absolute;
    top: -20px;
    right: 0;
    border-radius: 7px;
    border: none;
    background-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.textOnAccent};
    font-family: "SpaceGrotesk";
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    width: 92px;
    height: 40px;
    cursor: pointer;
  }
`;

export const TableNameWrap = styled.div`
  &.tableNameWrapTeamPlayer {
    display: flex;

    .react-tooltip {
      background: ${(props) => props.theme.cardBg};
      color: ${(props) => props.theme.textPrimary};
      font-family: "SatoshiBold";
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      line-height: 24px;
    }

    &:nth-child(n+3) { cursor: pointer; }

    &:nth-child(1) {
      padding-left: 44px;
      width: calc(32% - 17px);
    }
    &:nth-child(2) { width: 19.3%; }
    &:nth-child(6) { width: calc(5% + 5px); }
  }

  h5 {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-align: left;
    line-height: 18px;
    white-space: nowrap;
  }

  &:nth-child(1) { padding-left: 44px; width: calc(24% - 17px); }
  &:nth-child(2) { width: calc(19% + 5px); }
  &:nth-child(3) { width: calc(5% + 6px); h5 { text-align: center; } }
  &:nth-child(4) { width: calc(5% + 7px); }
  &:nth-child(5) { width: calc(5% + 17px); }
  &:nth-child(6) { width: calc(5% - 1px); h5 { text-align: center; } }
  &:nth-child(7) { width: calc(5% + 8px); }
  &:nth-child(8) { width: 5%; }
  &:nth-child(9) { width: 5%; }
  &:nth-child(10) { width: 5%; }
`;

export const TableNameWrapSmrtSearch = styled.div`
  h5 {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .react-tooltip {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
    z-index: 9;
  }

  &:nth-child(1) { width: calc(9% - 8px); margin-right: 5%; }
  &:nth-child(2) { width: calc(5% + 8px); }
  &:nth-child(3) { width: calc(14% - 6px); margin-right: 3%; }
  &:nth-child(n+4) { width: 3.13%; margin-right: 12px; white-space: nowrap; }
`;

export const TableWrap = styled.ul`
  border: 0.5px solid ${(props) => props.theme.borderColor};
  margin-bottom: 30px;
  max-height: 60vh;
  overflow: auto;
  ${visibleScrollbar};

  @media only screen and (${breakpoints.mobile}) {
    margin-bottom: 0px;
  }
`;

export const TableContent = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;

  &.tableLabelWrapTeamPlayer {
    h3 { text-align: center; }
    div:nth-child(n+3):not(:last-child) { width: 5%; }
  }

  h3 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }

  @media only screen and (${breakpoints.mobile}) { padding-left: 10px; }

  &:nth-child(odd)  { background: ${(props) => props.theme.row}; }
  &:nth-child(even) { background: ${(props) => props.theme.black}; }
`;

export const ProfileImage = styled.div`
  position: relative;
  display: flex;

  @media only screen and (${breakpoints.mobile}) {
    width: 20px;
    height: 20px;
  }

  .flag {
    position: absolute;
    object-fit: cover;
    top: -5px;
    right: -5px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  span {
    position: absolute;
    top: -9px;
    right: -6px;

    @media only screen and (${breakpoints.mobile}) {
      top: -12px;
      img { width: 10px; }
    }
  }
`;

export const Player = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 21%;

  &.teamPlayerTab {
    width: 33%;
    @media only screen and (${breakpoints.mobile}) { width: 60%; }
    h3 { max-width: 250px; }
  }

  h3 {
    max-width: 60px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media only screen and (${breakpoints.mobile}) { max-width: 120px; }
  }

  .react-tooltip {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
    z-index: 9;
  }

  @media only screen and (${breakpoints.mobile}) { width: 55%; }
`;

export const Position = styled.div`
  width: 20%;
  line-height: 0;

  &.smrtSearchPosition { width: 16%; }

  h3 {
    max-width: 100px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.playerTeamPage h3 { max-width: 180px; }

  .react-tooltip {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
  }
`;

export const Club = styled.div`
  width: 16%;

  h3 {
    max-width: 100px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .react-tooltip {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
  }
`;

export const Passes = styled.div`
  width: 6%;
  h3 { text-align: center; }
`;

export const RightContent = styled.div`
  width: 17%;
  display: flex;
  margin-left: auto;

  @media only screen and (${breakpoints.mobile}) { width: 40%; }
`;

export const SeeMoreWrap = styled.div`
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiBold";
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-align: right;
  line-height: 24px;
  padding: 20px;
  text-transform: capitalize;
  cursor: pointer;

  @media only screen and (${breakpoints.mobile}) {
    padding: 17px 10px;
    width: 95px;
  }
`;

export const Compare = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 20px;

  .react-tooltip {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
  }
`;

export const ImagesWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FilterButton = styled.div`
  width: 44px;
  height: 44px;
  background-color: ${(props) => props.theme.green};
  border-radius: 50%;
  position: absolute;
  bottom: 40px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BetaVersion = styled.div`
  position: absolute;
  right: 0;
  bottom: 120px;
  background: ${(props) => props.theme.green};
  padding: 10px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 999;

  img { width: 30px; height: 30px; }

  span {
    position: relative;
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => props.theme.textOnAccent};
    width: 300px;

    img {
      position: absolute;
      right: 2px;
      top: 2px;
      width: 15px;
      height: 15px;
    }
  }
`;

/* ── Workspace ─────────────────────────────────────────────────────────────── */

export const SmrtSearchWorkspace = styled.section`
  position: relative;
  margin: 8px 0 40px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 10px;
  overflow: visible;
  background: ${(props) => props.theme.workspaceBg};
`;

export const SmrtSearchTopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 0.5px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.cardBg};

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TemplateHeaderTitle = styled.h1`
  margin: 0;
  color: ${(props) => props.theme.textPrimary};
  font-family: "SpaceGrotesk";
  font-size: 28px;
  font-weight: 500;
  line-height: 1.2;

  @media only screen and (${breakpoints.mobile}) { font-size: 24px; }
`;

export const TemplateControlsRow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-left: auto;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    align-items: stretch;
    margin-left: 0;
    width: 100%;
  }
`;

export const TemplateSelectWrap = styled.div`
  position: relative;
  min-width: 210px;

  @media only screen and (${breakpoints.mobile}) { width: 100%; min-width: 0; }
`;

export const TemplateSelect = styled.select`
  width: 100%;
  min-width: 210px;
  min-height: 40px;
  padding: 9px 40px 9px 12px;
  border: 0.5px solid ${(props) => props.$placeholder ? props.theme.borderColor : props.theme.green};
  border-radius: 7px;
  background: ${(props) => props.$placeholder ? props.theme.inputBg : props.theme.accentBg};
  color: ${(props) => props.$placeholder ? props.theme.textPlaceholder : props.theme.textPrimary};
  font-family: "SatoshiMedium";
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover { border-color: ${(props) => props.theme.green}; }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.green};
    background: ${(props) => props.theme.accentBg};
    color: ${(props) => props.theme.textPrimary};
  }

  option {
    background: ${(props) => props.theme.cardBg};
    color: ${(props) => props.theme.textPrimary};
    text-transform: none;
    letter-spacing: 0;
    font-weight: 500;
  }
`;

export const TemplateSelectChevron = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${(props) => props.theme.textMuted};
  font-size: 11px;
`;

export const TemplateSaveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 13px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: transparent;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.green};
  }
`;

export const SmrtSearchPanel = styled.div`
  position: relative;
  z-index: 2;
  overflow: visible;
  padding: 16px 20px 20px;
  border-bottom: 0.5px solid ${(props) => props.theme.borderSubtle};
  background: ${(props) => props.theme.cardBg};
`;

export const QuickFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 6px;
  margin-bottom: 12px;
`;

export const QuickFilterPill = styled.button`
  padding: 0 0 2px;
  border: none;
  border-radius: 0;
  background: transparent;
  color: ${(props) => props.$active ? props.theme.green : props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 11px;
  letter-spacing: 0.08em;
  line-height: 1.2;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: ${(props) =>
    props.$active
      ? `inset 0 -1px 0 ${props.theme.green}`
      : "inset 0 -1px 0 transparent"};
  transition: color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    color: ${(props) => props.$active ? props.theme.green : props.theme.textSecondary};
  }
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;

  @media only screen and (max-width: 1100px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media only screen and (${breakpoints.mobile}) { grid-template-columns: 1fr; }
`;

export const FilterField = styled.div`
  min-width: 0;
`;

export const FilterLabel = styled.label`
  display: block;
  margin-bottom: 3px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 10px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`;

export const FieldControl = styled.select`
  display: block;
  width: 100%;
  max-width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 0 24px 0 8px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 1.2;

  &:focus { outline: none; border-color: ${(props) => props.theme.green}; }
`;

export const FieldInput = styled.input`
  display: block;
  width: 100%;
  max-width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 0 8px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 1.2;

  &::placeholder { color: ${(props) => props.theme.textPlaceholder}; font-size: 10px; }
  &:focus { outline: none; border-color: ${(props) => props.theme.green}; }
`;

export const FilterDropdownWrap = styled.div`
  position: relative;
  z-index: 1;
  &:focus-within { z-index: 6; }
`;

export const FilterDropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;
  padding: 7px 9px;
  border: 0.5px solid ${(props) => props.$open ? props.theme.green : props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.$open ? props.theme.accentBg : props.theme.inputBg};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover { border-color: ${(props) => props.theme.blueish3}; }
  &:focus { outline: none; border-color: ${(props) => props.theme.green}; }
`;

export const FilterDropdownTriggerValue = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: ${(props) => props.$placeholder ? props.theme.textPlaceholder : props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 1.2;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FilterDropdownChevron = styled.span`
  margin-left: 8px;
  color: ${(props) => props.$open ? props.theme.green : props.theme.textDisabled};
  font-size: 10px;
  line-height: 1;
  transform: ${(props) => props.$open ? "rotate(180deg)" : "rotate(0deg)"};
  transition: transform 0.15s ease, color 0.15s ease;
`;

export const FilterDropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 40;
  padding: 8px;
  border: 0.5px solid ${(props) => props.theme.dropdownBorder};
  border-radius: 10px;
  background: ${(props) => props.theme.dropdownBg};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
`;

export const FilterDropdownSearchInput = styled.input`
  display: block;
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  margin-bottom: 8px;
  padding: 0 10px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiMedium";
  font-size: 11px;

  &::placeholder { color: ${(props) => props.theme.textPlaceholder}; }
  &:focus { outline: none; border-color: ${(props) => props.theme.green}; }
`;

export const FilterDropdownOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: min(320px, 42vh);
  overflow: auto;
  overscroll-behavior: contain;
  ${visibleScrollbar};
`;

export const FilterDropdownOptionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 8px 10px;
  border: 0.5px solid ${(props) => props.$active ? props.theme.accentBorder : "transparent"};
  border-radius: 7px;
  background: ${(props) => props.$active ? props.theme.accentBg : "transparent"};
  color: ${(props) => props.$active ? props.theme.green : props.theme.textSecondary};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${(props) => props.theme.borderColor};
    background: ${(props) => props.theme.cardBgAlt};
    color: ${(props) => props.theme.textPrimary};
  }
`;

export const FilterDropdownOptionText = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 1.35;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FilterDropdownOptionCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 0.5px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  border-radius: 4px;
  background: ${(props) => props.$active ? props.theme.accentBg : "transparent"};
  color: ${(props) => props.$active ? props.theme.green : "transparent"};
  font-size: 10px;
  line-height: 1;
`;

export const FilterDropdownEmptyState = styled.div`
  padding: 10px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 11px;
  text-align: left;
`;

export const FilterDropdownActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 8px;
  padding: 8px 10px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiBold";
  font-size: 11px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.green};
  }

  &:disabled { cursor: wait; opacity: 0.55; }
`;

export const RangeFieldRow = styled.div`
  display: flex;
  gap: 5px;
  > * { flex: 1 1 0; min-width: 0; }
`;

export const ActiveChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-height: 22px;
  margin-bottom: 8px;
`;

export const ActiveChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border: 0.5px solid ${(props) => props.theme.accentBorder};
  border-radius: 10px;
  background: ${(props) => props.theme.accentBg};
  color: ${(props) => props.theme.green};
  font-family: "SatoshiMedium";
  font-size: 10px;
`;

export const ActiveChipRemove = styled.button`
  border: none;
  background: transparent;
  color: inherit;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.7;

  &:hover { opacity: 1; }
`;

export const AdvancedToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
  padding: 11px 14px;
  margin: 6px 0 10px;
  border: 0.5px solid ${(props) => props.$active ? props.theme.accentBorder : props.theme.borderColor};
  border-radius: 10px;
  background: ${(props) => props.$active ? props.theme.accentBg : props.theme.cardBgAlt};
  color: ${(props) => props.$active ? props.theme.green : props.theme.textMuted};
  font-family: "SatoshiBold";
  font-size: 12px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${(props) => props.theme.accentBorder};
    background: ${(props) => props.theme.accentBg};
    color: ${(props) => props.theme.green};
  }
`;

export const AdvancedToggleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$group ? "25px" : "14px"};
  height: ${(props) => props.$group ? "25px" : "14px"};
  border: 0.5px solid ${(props) =>
    props.$group
      ? props.theme.borderColor
      : (props.$active ? props.theme.green : props.theme.borderColor)};
  border-radius: ${(props) => props.$group ? "7px" : "3px"};
  background: ${(props) => props.$group ? props.theme.cardBgAlt : "transparent"};
  color: ${(props) =>
    props.$group
      ? props.theme.textSecondary
      : (props.$active ? props.theme.green : "inherit")};
  font-size: ${(props) => props.$group ? "16px" : "9px"};
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
`;

export const AdvancedBody = styled.div`
  overflow: hidden;
  max-height: ${(props) => props.$expanded ? "9999px" : "0"};
  padding-top: ${(props) => props.$expanded ? "8px" : "0"};
  transition: max-height 0.3s ease;
`;

export const AdvancedParamGroup = styled.div`
  margin-bottom: 12px;
  padding: 0 22px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 10px;
  background: ${(props) => props.theme.cardBgAlt};

  &:last-of-type { margin-bottom: 0; }

  @media only screen and (${breakpoints.mobile}) { padding: 0 16px; }
`;

export const AdvancedParamGroupHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  @media only screen and (${breakpoints.mobile}) { min-height: 48px; }
`;

export const AdvancedParamGroupTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiBold";
  font-size: 13px;
  line-height: 1.2;
  text-align: left;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
    flex-shrink: 0;
  }
`;

export const AdvancedParamGroupBody = styled.div`
  display: ${(props) => props.$expanded ? "block" : "none"};
  padding: 0 0 18px;

  @media only screen and (${breakpoints.mobile}) { padding-bottom: 14px; }
`;

export const AdvancedParamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 0;

  @media only screen and (max-width: 1100px) { grid-template-columns: 1fr; }
  @media only screen and (${breakpoints.mobile}) { grid-template-columns: 1fr; }
`;

export const AdvancedParamRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.cardBg};
`;

export const AdvancedParamLabel = styled.div`
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 1.4;
`;

export const AdvancedParamInputs = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  > * { min-width: 0; }
  @media only screen and (${breakpoints.mobile}) { grid-template-columns: 1fr; }
`;

export const AdvancedParamEmptyState = styled.div`
  padding: 14px 0 6px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 12px;
`;

export const WorkspaceSearchButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 18px;
`;

export const WorkspaceSearchButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 164px;
  padding: 9px 18px;
  border: none;
  border-radius: 999px;
  background: ${(props) => props.theme.green};
  color: ${(props) => props.theme.textOnAccent};
  font-family: "SpaceGrotesk";
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover { opacity: 0.9; }
  &:disabled { cursor: wait; opacity: 0.7; }

  @media only screen and (${breakpoints.mobile}) { width: 100%; }
`;

export const ResultsSection = styled.div`
  padding: 16px 20px 24px;
  background: ${(props) => props.theme.cardBg};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ResultsCount = styled.div`
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 13px;

  span {
    color: ${(props) => props.theme.green};
    font-family: "SatoshiBold";
  }
`;

export const ResultsSortRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media only screen and (${breakpoints.mobile}) { width: 100%; flex-wrap: wrap; }
`;

export const ResultsSortLabel = styled.span`
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 11px;
`;

export const ResultsSortSelect = styled.select`
  padding: 5px 8px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 11px;
  cursor: pointer;

  &:focus { outline: none; border-color: ${(props) => props.theme.green}; }
`;

export const ViewToggleGroup = styled.div`
  display: flex;
  gap: 4px;
`;

export const ViewToggleButton = styled.button`
  padding: 5px 9px;
  border: 0.5px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.$active ? props.theme.accentBg : props.theme.cardBgAlt};
  color: ${(props) => props.$active ? props.theme.green : props.theme.textMuted};
  font-size: 12px;
  cursor: pointer;
`;

export const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
`;

export const PlayerCard = styled.article`
  overflow: visible;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 10px;
  background: ${(props) => props.theme.cardBg};
  transition: border-color 0.15s ease;

  &:hover { border-color: ${(props) => props.theme.green}; }
`;

export const PlayerCardTop = styled.div`
  position: relative;
  padding: 14px 14px 10px;
  border-bottom: 0.5px solid ${(props) => props.theme.borderSubtle};
  background: ${(props) => props.theme.cardBgAlt};
  border-radius: 10px;
  min-height: 150px;
`;

export const PlayerCardIdentity = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

export const PlayerCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const PlayerAvatar = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$compact ? "36px" : "44px"};
  height: ${(props) => props.$compact ? "36px" : "44px"};
  border-radius: 50%;
  background: ${(props) => props.$background || props.theme.accentBg};
  color: ${(props) => props.$color || props.theme.green};
  font-family: "SpaceGrotesk";
  font-size: ${(props) => props.$compact ? "12px" : "14px"};
  font-weight: 700;
  flex-shrink: 0;
`;

export const PlayerAvatarImage = styled.img`
  display: block;
  width: ${(props) => props.$compact ? "36px" : "44px"};
  height: ${(props) => props.$compact ? "36px" : "44px"};
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  flex-shrink: 0;
  background: ${(props) => props.theme.cardBgAlt};
`;

export const PlayerCardName = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  gap: 6px;
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiBold";
  font-size: 13px;
  line-height: 1.3;
`;

export const PlayerIdentityActionGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

export const PlayerIdentityActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.15s ease, transform 0.15s ease;

  &:hover { opacity: 1; transform: translateY(-1px); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 1px ${(props) => props.theme.green}; }

  img { width: 14px; height: 14px; object-fit: contain; display: block; }
`;

export const PlayerIdentityNameLink = styled.a`
  min-width: 0;
  color: inherit;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.15s ease;

  &:hover { color: ${(props) => props.theme.green}; }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 1px ${(props) => props.theme.green};
    border-radius: 3px;
  }
`;

export const PlayerCardMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 11px;
`;

export const PlayerMetaLink = styled.a`
  color: inherit;
  text-decoration: none;
  border-radius: 4px;
  transition: color 0.15s ease;
  font-size: 12px;

  &:hover { color: ${(props) => props.theme.green}; text-decoration: none; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 1px ${(props) => props.theme.green}; }
`;

export const PlayerMetaText = styled.span`
  color: ${(props) => props.theme.textMuted};
`;

export const PositionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 10px;
  background: ${(props) => {
    switch (props.$position) {
      case "GK":  return "#FFF3CD";
      case "MID": return "#FFF3CD";
      default:    return props.theme.accentBg;
    }
  }};
  color: ${(props) => {
    switch (props.$position) {
      case "GK":  return "#856404";
      case "MID": return "#856404";
      default:    return props.theme.green;
    }
  }};
  font-family: "SatoshiBold";
  font-size: 9px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const PlayerCardActions = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const CardActionToggle = styled.button`
  display: inline-flex;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  background: ${(props) => props.theme.cardBg};
  color: ${(props) => props.theme.textSecondary};
  cursor: pointer;
`;

export const CardActionMenu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 5;
  min-width: 148px;
  padding: 6px;
  border: 0.5px solid ${(props) => props.theme.dropdownBorder};
  border-radius: 7px;
  background: ${(props) => props.theme.dropdownBg};
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
`;

export const CardActionItem = styled.button`
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 12px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.cardBgAlt};
    color: ${(props) => props.theme.green};
  }
`;

export const PlayerCardStats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
  gap: 6px;
  padding: 10px 14px;
  border-top: 0.5px solid ${(props) => props.theme.borderSubtle};
`;

export const PlayerCardStat = styled.div`
  text-align: center;
`;

export const PlayerCardStatValue = styled.div`
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiBold";
  font-size: 14px;
`;

export const PlayerCardStatLabel = styled.div`
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 9px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const SmrtIndexBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 12px;
  border-top: 0.5px solid ${(props) => props.theme.borderSubtle};
`;

export const SmrtIndexLabel = styled.span`
  white-space: nowrap;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 10px;
`;

export const SmrtIndexTrack = styled.div`
  flex: 1;
  height: 4px;
  border-radius: 3px;
  overflow: hidden;
  background: ${(props) => props.theme.borderColor};
`;

export const SmrtIndexFill = styled.div`
  width: ${(props) => props.$width || "0%"};
  height: 100%;
  border-radius: 3px;
  background: ${(props) => props.theme.green};
`;

export const SmrtIndexValue = styled.span`
  min-width: 26px;
  color: ${(props) => props.theme.green};
  font-family: "SatoshiBold";
  font-size: 11px;
  text-align: right;
`;

export const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PlayerListRow = styled.article`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.theme.cardBgAlt};
  transition: border-color 0.15s ease;

  &:hover { border-color: ${(props) => props.theme.green}; }

  @media only screen and (${breakpoints.mobile}) { flex-wrap: wrap; }
`;

export const PlayerListInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PlayerListName = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiBold";
  font-size: 13px;
`;

export const PlayerListMeta = styled.div`
  margin-top: 1px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 11px;
`;

export const PlayerListStats = styled.div`
  display: flex;
  gap: 16px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media only screen and (${breakpoints.mobile}) { width: 100%; justify-content: space-between; }
`;

export const PlayerListSmrt = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  min-width: 90px;

  @media only screen and (${breakpoints.mobile}) { width: 100%; }
`;

export const WorkspaceEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 220px;
  padding: 32px 16px 12px;
  text-align: center;

  img { width: 72px; height: 72px; }

  h3 {
    color: ${(props) => props.theme.textPrimary};
    font-family: "SpaceGrotesk";
    font-size: 20px;
    line-height: 28px;
  }

  p {
    max-width: 420px;
    color: ${(props) => props.theme.textMuted};
    font-family: "SatoshiRegular";
    font-size: 14px;
    line-height: 22px;
  }
`;

export const LoadingState = styled.div`
  padding: 32px 0;
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 14px;
  text-align: center;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  padding-bottom: 8px;
  flex-wrap: wrap;
`;

export const PaginationButton = styled.button`
  min-width: 38px;
  padding: 6px 12px;
  border: 0.5px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) => props.$active ? props.theme.accentBg : props.theme.cardBgAlt};
  color: ${(props) => props.$active ? props.theme.green : props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 12px;
  cursor: pointer;

  &:hover {
    border-color: ${(props) => props.$active ? props.theme.green : props.theme.blueish3};
    color: ${(props) => props.$active ? props.theme.green : props.theme.textSecondary};
  }

  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

export const PaginationEllipsis = styled.span`
  padding: 0 4px;
  color: ${(props) => props.theme.textDisabled};
  font-size: 12px;
`;

export const TemplateModalLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: rgba(0, 0, 0, 0.5);
`;

export const TemplateModalCard = styled.div`
  width: 100%;
  max-width: 560px;
  padding: 56px 48px 36px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 12px;
  background: ${(props) => props.theme.cardBg};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);

  @media only screen and (${breakpoints.mobile}) {
    max-width: 100%;
    padding: 44px 20px 28px;
  }
`;

export const TemplateModalTitle = styled.h3`
  margin: 0 0 10px;
  color: ${(props) => props.theme.textPrimary};
  font-family: "SpaceGrotesk";
  font-size: 28px;
  font-weight: 700;
  line-height: 1.15;
  text-align: left;

  @media only screen and (${breakpoints.mobile}) { font-size: 24px; }
`;

export const TemplateModalText = styled.p`
  margin: 0 0 28px;
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiRegular";
  font-size: 16px;
  line-height: 1.5;
  text-align: left;

  @media only screen and (${breakpoints.mobile}) { margin-bottom: 24px; font-size: 15px; }
`;

export const TemplateModalInput = styled.input`
  width: 100%;
  margin-bottom: 12px;
  padding: 18px 22px;
  border: 0.5px solid ${(props) => props.$error ? props.theme.red : props.theme.borderColor};
  border-radius: 10px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.textPrimary};
  font-family: "SatoshiMedium";
  font-size: 18px;
  line-height: 1.4;
  transition: border-color 0.2s ease;

  &::placeholder { color: ${(props) => props.theme.textPlaceholder}; }
  &:focus {
    outline: none;
    border-color: ${(props) => props.$error ? props.theme.red : props.theme.green};
  }

  @media only screen and (${breakpoints.mobile}) { padding: 16px 18px; font-size: 16px; }
`;

export const TemplateModalError = styled.div`
  min-height: 20px;
  margin-bottom: 6px;
  color: ${(props) => props.theme.red};
  font-family: "SatoshiRegular";
  font-size: 12px;
  line-height: 1.4;
  text-align: left;
`;

export const TemplateModalActions = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 14px;
  margin-top: 24px;
`;

export const TemplateModalSecondaryButton = styled.button`
  align-self: center;
  padding: 4px 12px;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.textSecondary};
  font-family: "SatoshiMedium";
  font-size: 16px;
  line-height: 1.4;
  cursor: pointer;
  opacity: 0.78;

  &:hover { opacity: 1; }
`;

export const TemplateModalPrimaryButton = styled.button`
  width: 100%;
  padding: 14px 18px;
  border: none;
  border-radius: 10px;
  background: ${(props) => props.theme.green};
  color: ${(props) => props.theme.textOnAccent};
  font-family: "SpaceGrotesk";
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;

  &:hover { opacity: 0.9; }
`;

export const TemplateToast = styled.div`
  position: absolute;
  left: 50%;
  bottom: 16px;
  z-index: 9;
  padding: 8px 16px;
  border: 0.5px solid ${(props) => props.theme.accentBorder};
  border-radius: 20px;
  background: ${(props) => props.theme.accentBg};
  color: ${(props) => props.theme.green};
  font-family: "SatoshiMedium";
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  transform: translateX(-50%);
  opacity: ${(props) => props.$visible ? 1 : 0};
  transition: opacity 0.2s ease;
`;

export const TutorialButton = styled.button`
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  background: ${(props) => props.theme.cardBg};
  border: 0.5px solid ${(props) => props.theme.accentBorder};
  color: ${(props) => props.theme.green};
  padding: 8px 18px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.green};
    color: ${(props) => props.theme.textOnAccent};
    opacity: 1;
  }
`;
